import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getEmployeesQueryKey } from "modules/settings/lib/employeesQuery"
import { DataResponse, EmployeeSchema, GetEmployeeSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof EmployeeSchema>>

type Props = z.infer<typeof GetEmployeeSchema>

export function useArchiveEmployeeMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (props: Props) => {
      const response = await axios.put<Response>(`/employees/${props.id}/archive`)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [getEmployeesQueryKey().at(0)] })
    },
  })
}
